<template>
  <div class="contact-block panel panel-default sidebar-menu wow fadeInLeft animated">
    <div class="panel-heading">
			<h3 class="panel-title">{{ $t("labels.documents") }}</h3>
		</div>

    <div class="panel-body text-widget">
      <span class="mb-1 fs-16 d-block">
        {{ $t('configurator.labels.printing_information') }}
      </span>
      <template v-for="document in printDocuments" :key="document.id">
        <a class="cursor--pointer d-block" @click="download(document)">
          <em class="fa fa-file-pdf-o mr-1" aria-hidden="true"></em>
          {{ (inEnglish) ? document.name_en : document.name }}
        </a>
      </template>

      <span v-if="boothDocuments.length > 0" class="my-1 fs-16 d-block">
        {{ $t('configurator.labels.booth_package') }}
      </span>
      <template v-for="document in boothDocuments" :key="document.hash">
        <a :href="'/storage/' + document.path" class="d-block" target="_blank">
          <em class="fa fa-file-pdf-o mr-1" aria-hidden="true"></em>
          {{ (inEnglish) ? document.title_en : document.title_de }}
        </a>
      </template>
      <p v-if="!documentsAvailable">
        {{ $t('configurator.labels.no_documents_available') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { useMainStore } from '@/store'
import { computed } from 'vue'
import { downloadPrintingInformation } from '@/utils/file'

const mainStore = useMainStore()

// computed props
const exhibitionSlug = computed(() => mainStore.tmp.exhibition_slug)
const inEnglish = computed(() => mainStore.inEnglish)
const printDocuments = computed(() => mainStore.tmp.printing_information)
const boothDocuments = computed(() => mainStore.tmp.booth_package_documents)

const documentsAvailable = computed(() => {
  return printDocuments.value.length > 0 || boothDocuments.value.length > 0
})

// methods
const download = async (document) => {
  await downloadPrintingInformation(
    document.identifier,
    exhibitionSlug.value,
    ((inEnglish.value) ? document.name_en : document.name) + '.' + document.extension
  )
}
</script>